import React, {
  useContext,
  useMemo,
  useState,
  useCallback,
  useEffect,
} from 'react';

import api, { Pergunta } from 'api/DuvidasFrequentes';

import {
  Badge,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Popover,
} from '@material-ui/core';
import { BellIcon } from 'components/Icons';

import Context from '../Context';
import useStyle from './style';

export default function Notificacao() {
  const classes = useStyle();
  const {
    perguntas,
    atualizarPergunta,
    isPerguntaUsuario,
    isPerguntaNaoLida,
    setDestaque,
  } = useContext(Context);
  const [anchorEl, setAnchor] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchor(event.currentTarget);
  };

  const handleClose = () => {
    setAnchor(null);
  };

  const handleSelect = useCallback(
    (pergunta: Pergunta) => {
      return () => {
        handleClose();
        setDestaque(pergunta.idDuvidaFrequente, true);
      };
    },
    [setDestaque]
  );

  const perguntasNaoLidas = useMemo(() => {
    return (perguntas || [])
      .filter(isPerguntaUsuario)
      .filter(isPerguntaNaoLida);
  }, [perguntas, isPerguntaUsuario, isPerguntaNaoLida]);

  const perguntasNaoLidasGeral = useMemo(() => {
    return (perguntas || []).filter(isPerguntaNaoLida);
  }, [perguntas, isPerguntaNaoLida]);

  const marcarComoLido = useCallback(
    (pergunta: Pergunta) => {
      return async () => {
        const { response } = await api.lido(pergunta.idDuvidaFrequente);
        if (response && response.status === 200) {
          atualizarPergunta({
            ...pergunta,
            lido: true,
          });
        }
      };
    },
    [atualizarPergunta]
  );

  const getStorage: any = localStorage.getItem('notificacaoChat');
  const parseStorage = JSON.parse(getStorage);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const badgeContent = () => {
    if (parseStorage!?.somenteMinhasNotificacoes === true) {
      return perguntasNaoLidas.length;
    } else {
      return perguntasNaoLidasGeral.length;
    }
  };

  useEffect(() => {
    badgeContent();
  }, [badgeContent, getStorage]);

  return (
    <React.Fragment>
      <IconButton
        color='primary'
        className={classes.button}
        onClick={handleClick}
        disabled={!badgeContent()}
      >
        <Badge
          badgeContent={badgeContent()}
          color='error'
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          overlap='rectangular'
        >
          <BellIcon />
        </Badge>
      </IconButton>
      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          className: classes.card,
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <List className={classes.list}>
          {parseStorage!?.somenteMinhasNotificacoes === true
            ? perguntasNaoLidas.map((pergunta) => (
                <ListItem
                  key={pergunta.idDuvidaFrequente}
                  component='li'
                  onClick={handleSelect(pergunta)}
                  onFocus={marcarComoLido(pergunta)}
                  className={classes.item}
                  button
                >
                  <ListItemText
                    primary={pergunta.duvida}
                    className={classes.text}
                  />
                </ListItem>
              ))
            : perguntasNaoLidasGeral.map((pergunta) => (
                <ListItem
                  key={pergunta.idDuvidaFrequente}
                  component='li'
                  onClick={handleSelect(pergunta)}
                  onFocus={marcarComoLido(pergunta)}
                  className={classes.item}
                  button
                >
                  <ListItemText
                    primary={pergunta.duvida}
                    className={classes.text}
                  />
                </ListItem>
              ))}
        </List>
      </Popover>
    </React.Fragment>
  );
}
